// extracted by mini-css-extract-plugin
module.exports = {"drag":"MediaCollectionPage_drag__3dqlJ","empty":"MediaCollectionPage_empty__1BP6k","progress":"MediaCollectionPage_progress__3vMM_"};